import { createTheme } from '@material-ui/core/styles';
import { merge, isEmpty } from 'lodash';

import { colorBlue1, colorBlue4, colorGrey1, colorGrey5 } from './../../../../../scss/_colors.scss';

const themeOverrides = {
    overrides: {
        MuiPaper: {
            root: {
                width: '100%',
                boxShadow: 'none !important',
            }
        },
        MuiTable: {
            root: {
                width: '100%',
                borderBottom: 'none !important',
            }
        },
        MuiTableBody: {
            root: {
                '& > tr:first-child': {
                    paddingTop: '0px !important',
                    paddingBottom: '0px !important',
                },
            },
        },
        MuiTableCell: {
            head: {
                zIndex: '0 !important',
                color: colorGrey1,
                fontWeight: '500',
                letterSpacing: '0.1mm',
                fontSize: '16px',
                paddingTop: '0px !important',
                paddingBottom: '0px !important',
                marginRight: '0px !important',
            },
            root: {
                paddingTop: '0px !important',
                paddingBottom: '0px !important',
                borderBottom: 'none !important',
                marginRight: '0px !important',
                height: '48px',
                lineHeight: '1',
                width: '100%',
                background: 'inherit',
                '&:first-child': {
                    zIndex: '1 !important',
                    position: 'sticky !important',
                    left: '0 !important',
                },
                '&:nth-child(1)': {
                    zIndex: '1 !important',
                    position: 'sticky !important',
                },
            },
        },
        MuiTableRow: {
            root: {
                '& > td:last-child': {
                    '& > a:last-child': {
                        visibility: 'hidden',
                    },
                    '& > button:last-child': {
                        visibility: 'hidden',
                    },
                },
                background: '#FFF',
                position: 'relative !important',
                zIndex: '0 !important',
            },
            hover: {
                '&:hover': {
                    backgroundColor: `${colorBlue4} !important`,
                    '& > td:last-child': {
                        color: 'blue',
                        '& > a:last-child': {
                            visibility: 'visible',
                        },
                        '& > button:last-child': {
                            visibility: 'visible',
                        }
                    },
                }
            },
        },
        MuiTablePagination: {
            root: {
                overflowY: 'hidden !important',
            },
        },
        MuiInputBase: {
            root: {
                '&::before': {
                    borderBottom: 'none !important',
                },
                '&::after': {
                    borderBottom: 'none !important',
                },
                backgroundColor: colorGrey5,
                padding: '4px !important',
            },
            input: {
                color: 'black !important',
                '&::placeholder': {
                    opacity: '1',
                    color: 'black !important',
                }
            }
        },
        MuiPopover: {
            paper: {
                backgroundColor: '#F4F5F7',
            },
        },
        MuiCheckbox: {
            colorSecondary: {
                '&.Mui-checked': { color: colorBlue1 }
            },
        },
        MuiFormControl: {
            root: {
                width: '100%'
            }
        },
        MuiSvgIcon: {
            root: {
                color: colorBlue1
            },
        },
    }
};

const scrollbarOverrides = {
    overrides: {
        MuiPaper: {
            root: {
                width: '100%',
                boxShadow: 'none !important',
                overflowX: 'auto',
                overflowY: 'scroll',
                '-ms-overflow-style': 'none',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
            }
        },
    }
};


export const theme = createTheme(merge(themeOverrides, scrollbarOverrides));

export const customTheme = (overrides) => {
    if (isEmpty(overrides)) return theme;

    const mergeOverrides = merge({}, themeOverrides, { overrides });
    return createTheme(mergeOverrides);
};

